export default "__VITE_ASSET__nJyFKefE__"